import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WeddingPage from "@/components/WeddingPage";
import AdminPage from "@/components/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WeddingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/info" element={<WeddingPage showGift={true} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
